import * as React from 'react';
import { CaptionTypography } from '@components/atoms';
import { cn } from '@utils';

/**
 * Interface for the props of the select empty state component.
 * @returns {ISelectEmptyStateProps} - The props object.
 */
export interface ISelectEmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
	label: string;
}

/**
 * Component for the empty state of the select component.
 * @param {ISelectEmptyStateProps} props - The props of the component.
 * @returns {React.ReactNode} - The empty state component.
 */
export const SelectEmptyState = ({
	className,
	label,
	...props
}: ISelectEmptyStateProps): React.ReactElement => {
	return (
		<div
			{...props}
			aria-live="polite"
			className={cn('flex min-h-12 items-center justify-center px-4 py-3 text-center', className)}
			data-testid="select-empty-state"
			role="status"
		>
			<CaptionTypography className="text-secondary">{label}</CaptionTypography>
		</div>
	);
};
